/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Pairing_OffersInputs */

const cs_ebr_pairing_offers = /** @type {(inputs: Ebr_Pairing_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky ↔ nemovitosti a makléři`)
};

const en_ebr_pairing_offers = /** @type {(inputs: Ebr_Pairing_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers ↔ properties and brokers`)
};

/**
* | output |
* | --- |
* | "Offers ↔ properties and brokers" |
*
* @param {Ebr_Pairing_OffersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_pairing_offers = /** @type {((inputs?: Ebr_Pairing_OffersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Pairing_OffersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_pairing_offers(inputs)
	return cs_ebr_pairing_offers(inputs)
});